import { Component, h } from '@stencil/core';

@Component({
  tag: 'kdx-scroll-top',
  styleUrl: 'kdx-scroll-top.scss',
  shadow: false,
})
export class KdxScrollTop {

  private isShown = false;

  componentDidRender() {
    const btn: HTMLElement = document.querySelector('.btn-scroll-to-top');

    window.addEventListener('scroll', () => {
      if (window.scrollY > 350 && !this.isShown) {
        globalThis.fade_in(btn);
        this.isShown = true;
      } else if (window.scrollY <= 350 && this.isShown) {
        globalThis.fade_out(btn);
        this.isShown = false;
      }
    });

    btn.onclick = (e) => {
      e.preventDefault();
      window.scrollTo({top: 0, behavior: 'smooth'});
    };
  }

  render() {
    return (
      <button class="btn-scroll-to-top" aria-label="Scroll to top of page">
        <kdx-icon icon="chevron-up"></kdx-icon>        
      </button>
    );
  }

}
